const FORBIDDEN_CHARACTERS_PATTERN = /[\\/:*?"<>|]/g;
const DEFAULT_FILENAME = 'document.docx';

/** Turns a document's title into a filesystem-safe `.docx` name: every character forbidden on Windows
 * (`\ / : * ? " < > |`) becomes a dash, the result is trimmed, and an empty title falls back to
 * `document.docx` rather than downloading a dot-file. */
const buildDocumentExportFilename = (title: string): string => {
	const sanitized = title.replace(FORBIDDEN_CHARACTERS_PATTERN, '-').trim();

	return sanitized === '' ? DEFAULT_FILENAME : `${sanitized}.docx`;
};

export default buildDocumentExportFilename;
